import userService from "../../services/user.service";
import { getUserList } from "../../api/user.api";
import { useQuery } from "react-query";


export default function GetUserList(){
    const href = window.location.href
    const getList = useQuery(href,getUserList);
    return getList
}